/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Customer } from '../models/customer';
import { CustomerSummary } from '../models/customer-summary';
import { CustomerSettings } from '../models/customer-settings';
import { CustomerWithStatus } from '../models/customer-with-status';
@Injectable({
  providedIn: 'root',
})
class CustomerService extends __BaseService {
  static readonly CustomerCreateCustomerPath = '/api/Customer/CreateCustomer';
  static readonly CustomerUpdateCurrentCustomerPath = '/api/Customer/UpdateCurrentCustomer';
  static readonly CustomerGetAllCustomersPath = '/api/Customer/GetAllCustomers';
  static readonly CustomerGetAllCustomerDetailsPath = '/api/Customer/GetAllCustomerDetails';
  static readonly CustomerUnarchiveCustomerPath = '/api/Customer/UnarchiveCustomer';
  static readonly CustomerGetCustomerByIdPath = '/api/Customer/GetCustomerById';
  static readonly CustomerUpdateCustomerPath = '/api/Customer/UpdateCustomer';
  static readonly CustomerUpdateCustomerSettingsPath = '/api/Customer/UpdateCustomerSettings';
  static readonly CustomerGetCustomersWithStatusPath = '/api/Customer/GetCustomersWithStatus';
  static readonly CustomerGetCustomerLicensesPath = '/api/Customer/GetCustomerLicenses';
  static readonly CustomerDeleteCustomerByIdPath = '/api/Customer/DeleteCustomerById';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param model undefined
   */
  CustomerCreateCustomerResponse(model: Customer): __Observable<__StrictHttpResponse<Customer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Customer/CreateCustomer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Customer>;
      })
    );
  }
  /**
   * @param model undefined
   */
  CustomerCreateCustomer(model: Customer): __Observable<Customer> {
    return this.CustomerCreateCustomerResponse(model).pipe(
      __map(_r => _r.body as Customer)
    );
  }

  /**
   * @param model undefined
   */
  CustomerUpdateCurrentCustomerResponse(model: CustomerSummary): __Observable<__StrictHttpResponse<CustomerSummary>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Customer/UpdateCurrentCustomer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerSummary>;
      })
    );
  }
  /**
   * @param model undefined
   */
  CustomerUpdateCurrentCustomer(model: CustomerSummary): __Observable<CustomerSummary> {
    return this.CustomerUpdateCurrentCustomerResponse(model).pipe(
      __map(_r => _r.body as CustomerSummary)
    );
  }

  /**
   * @param includedArchived undefined
   */
  CustomerGetAllCustomersResponse(includedArchived?: null | boolean): __Observable<__StrictHttpResponse<Array<CustomerSummary>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (includedArchived != null) __params = __params.set('includedArchived', includedArchived.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/GetAllCustomers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CustomerSummary>>;
      })
    );
  }
  /**
   * @param includedArchived undefined
   */
  CustomerGetAllCustomers(includedArchived?: null | boolean): __Observable<Array<CustomerSummary>> {
    return this.CustomerGetAllCustomersResponse(includedArchived).pipe(
      __map(_r => _r.body as Array<CustomerSummary>)
    );
  }
  CustomerGetAllCustomerDetailsResponse(): __Observable<__StrictHttpResponse<Array<Customer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/GetAllCustomerDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Customer>>;
      })
    );
  }  CustomerGetAllCustomerDetails(): __Observable<Array<Customer>> {
    return this.CustomerGetAllCustomerDetailsResponse().pipe(
      __map(_r => _r.body as Array<Customer>)
    );
  }

  /**
   * @param customerId undefined
   */
  CustomerUnarchiveCustomerResponse(customerId?: number): __Observable<__StrictHttpResponse<Customer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/UnarchiveCustomer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Customer>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  CustomerUnarchiveCustomer(customerId?: number): __Observable<Customer> {
    return this.CustomerUnarchiveCustomerResponse(customerId).pipe(
      __map(_r => _r.body as Customer)
    );
  }

  /**
   * @param customerId undefined
   */
  CustomerGetCustomerByIdResponse(customerId?: number): __Observable<__StrictHttpResponse<Customer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/GetCustomerById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Customer>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  CustomerGetCustomerById(customerId?: number): __Observable<Customer> {
    return this.CustomerGetCustomerByIdResponse(customerId).pipe(
      __map(_r => _r.body as Customer)
    );
  }

  /**
   * @param model undefined
   */
  CustomerUpdateCustomerResponse(model: Customer): __Observable<__StrictHttpResponse<Customer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Customer/UpdateCustomer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Customer>;
      })
    );
  }
  /**
   * @param model undefined
   */
  CustomerUpdateCustomer(model: Customer): __Observable<Customer> {
    return this.CustomerUpdateCustomerResponse(model).pipe(
      __map(_r => _r.body as Customer)
    );
  }

  /**
   * @param model undefined
   */
  CustomerUpdateCustomerSettingsResponse(model: CustomerSettings): __Observable<__StrictHttpResponse<CustomerSettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Customer/UpdateCustomerSettings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CustomerSettings>;
      })
    );
  }
  /**
   * @param model undefined
   */
  CustomerUpdateCustomerSettings(model: CustomerSettings): __Observable<CustomerSettings> {
    return this.CustomerUpdateCustomerSettingsResponse(model).pipe(
      __map(_r => _r.body as CustomerSettings)
    );
  }

  /**
   * @param includeArchived undefined
   */
  CustomerGetCustomersWithStatusResponse(includeArchived?: null | boolean): __Observable<__StrictHttpResponse<Array<CustomerWithStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (includeArchived != null) __params = __params.set('includeArchived', includeArchived.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/GetCustomersWithStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CustomerWithStatus>>;
      })
    );
  }
  /**
   * @param includeArchived undefined
   */
  CustomerGetCustomersWithStatus(includeArchived?: null | boolean): __Observable<Array<CustomerWithStatus>> {
    return this.CustomerGetCustomersWithStatusResponse(includeArchived).pipe(
      __map(_r => _r.body as Array<CustomerWithStatus>)
    );
  }
  CustomerGetCustomerLicensesResponse(): __Observable<__StrictHttpResponse<Array<CustomerWithStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Customer/GetCustomerLicenses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CustomerWithStatus>>;
      })
    );
  }  CustomerGetCustomerLicenses(): __Observable<Array<CustomerWithStatus>> {
    return this.CustomerGetCustomerLicensesResponse().pipe(
      __map(_r => _r.body as Array<CustomerWithStatus>)
    );
  }

  /**
   * @param customerId undefined
   */
  CustomerDeleteCustomerByIdResponse(customerId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Customer/DeleteCustomerById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  CustomerDeleteCustomerById(customerId?: number): __Observable<Blob> {
    return this.CustomerDeleteCustomerByIdResponse(customerId).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module CustomerService {
}

export { CustomerService }
